import {Component, HostListener, OnInit, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {AppBaseComponent} from '../app-base-component/app-base-component';
import {ResizedImage} from '../resized-image/resized-image';
import {SOCKET_CONNECTED, UPDATE_BADGES} from '../../../event-disctionary';
import {Debounce} from '../../decorators/debouncer';
import {CounterBadge} from '../counter-badge/counter-badge';
import {Ripple} from 'primeng/ripple';

@Component({
  selector: 'app-app-header',
  standalone: true,
  imports: [CommonModule, RouterLink, ResizedImage, CounterBadge, RouterLinkActive],
  templateUrl: './app-header.html',
  styleUrls: ['./app-header.css']
})
export class AppHeader extends AppBaseComponent {
  isMenuOpen = false;
  isScrolled = false;

  constructor() {
    super();
    this.getBadges();
    this.unreadMessages();
    this.eventBus.on(SOCKET_CONNECTED).subscribe(() => {
      const channel = this.pusherService.pusher?.subscribe('private-user.' + this.authService.user().id)
      channel?.bind_global((event: any, data: any) => {
        switch (event) {
          case 'message:send':
            if (data.sender_id !== this.authService.user().id) this.unreadMessages();
            break;
          case 'update:badges':
            this.getBadges();
            break;
        }
      })
    })
    this.eventBus.on(UPDATE_BADGES).subscribe(res => this.getBadges());
  }

  @Debounce(500)
  unreadMessages() {
    if (!this.authService.isLoggedIn()) return;
    this.http.get('user/badges?type=messages').subscribe((res: any) => {
      this.badges.update(b => ({...b, messages: res.count}))
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.pageYOffset > 10;
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }

  badges = signal({match_count: 0, real_match_count: 0, messages: 0, likes: 0, saved: 0});

  getBadges() {
    if (!this.authService.isLoggedIn()) return;
    this.http.get('user/badges').subscribe((res: any) => this.badges.set(res))
  }

}
